import { ToolkitObject } from 'client/components/toolkit/objects/ToolkitObject';
import { DocumentToolkitObject } from '../DocumentToolkitObject';

export function isDocumentAccessible(obj: ToolkitObject<any>) {
  const document = DocumentToolkitObject.get(obj);
  return document?.data?.isAccessible ?? false;
}
